module.exports = __webpack_public_path__ + "img/camp_shirt_other7.3179cad9.svg";